import { apiQueryClient } from 'features/api/apiQueryClient'
import {
  fetchBillingScheduleAggregate,
  getBillingScheduleAggregateKey
} from './utils/useBillingScheduleAggregate'
import { LoaderFunction } from 'react-router-dom'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { INVOICES_FOR_SCHEDULE_PARAMS } from './billingScheduleHome.constants'

const requestWithTimeout =
  (timeout: number) =>
  (request: Promise<unknown>): Promise<unknown> =>
    Promise.race([request, new Promise(res => setTimeout(res, timeout))])

export const prefetchBillingScheduleHomeData = async (
  billingScheduleId: string
) => {
  await apiQueryClient.prefetchQuery({
    queryKey: getBillingScheduleAggregateKey(billingScheduleId),
    queryFn: () => fetchBillingScheduleAggregate(billingScheduleId),
    staleTime: 60000
  })
}

export const prefetchInvoicesForBillingSchedule = async (
  billingScheduleId: string
) => {
  const params = { billingScheduleId, ...INVOICES_FOR_SCHEDULE_PARAMS }

  await apiQueryClient.prefetchQuery({
    queryKey: [dashboardv99990101Client.getInvoices.queryKey, params],
    queryFn: () => dashboardv99990101Client.getInvoices.request(params),
    staleTime: 60000
  })
}

export const billingScheduleHomeLoader = async ({
  params
}: Parameters<LoaderFunction>[0]) => {
  const billingScheduleId = params.id

  if (!billingScheduleId) {
    return true
  }

  await Promise.all([
    requestWithTimeout(500)(prefetchBillingScheduleHomeData(billingScheduleId)),
    requestWithTimeout(500)(
      prefetchInvoicesForBillingSchedule(billingScheduleId)
    )
  ])

  return true
}
